import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import proctoring_img from "../../../assets/images/exams/proctoring.svg";
import chrome_img from "../../../assets/images/chrome.svg";

import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { TitleH2 } from "../../../components/TitleH2";
import { Text } from "../../../components/Text";
import { Button } from "../../../components/Button";
import { selectAppPersonalizations } from "../../../services/utils/appInfoSlice";
import { API_URL, BASE_URL } from "../../../config/constants";

export default function ProctoringModal(props) {

    const t = useSelector(selectTranslations)
    const appInfo = useSelector(selectAppPersonalizations)

    const [showMultipleScreenError, setShowMultipleScreenError] = useState(false)

    const onCloseModal = () => {
        props.handleClose();
    }

    const checkMultipleScreen = async () => {
        if ('getScreenDetails' in window) {
            try {
                const screenDetails = await window.getScreenDetails();
                const numberOfScreens = screenDetails.screens.length;
        
                if (numberOfScreens > 1) {
                console.log("Trovati più schermi:", numberOfScreens);
                return true;
                } else {
                console.log("Solo uno schermo rilevato.");
                return false;
                }
            } catch (err) {
                console.error("Errore nell'accesso a getScreenDetails():", err);
                return null;
            }
        } else {
            console.warn("Multi-Screen API non supportata su questo browser.");
            return null;
        }
    }

    const confirmClose = async () => {
        const multipleScreens = await checkMultipleScreen()
        if(multipleScreens !== null && multipleScreens) 
            alert(t.proctoring.errors.multiple_screens)
        else
            props.handleConfirm(true, true);
    }

    useEffect(() => {
        
        
    }, [props])

    return (
        <div>
            <Modal
                show={props.show}
                onHide={onCloseModal}
                keyboard={false}
                centered
            >
                <Modal.Body className="text-center">
                <div className="modal-content">
                    <div className="d-flex justify-content-center">
                        <img
                            alt="Procotoring"
                            className="noselect header_image"
                            src={proctoring_img}
                            width={48}
                        />
                    </div>
                    <TitleH2 id="modalTitle" style={{ textAlign: 'center', marginBottom: "16px", }} className="mt-3">{t.proctoring.start_title}</TitleH2>
                    <div className="mb-1 text-center">
                        <Text>{t.proctoring.start_text}</Text>
                    </div>
                    
                    <p style={{color:'var(--primary-color)'}} className="mb-3 text-center">{t.proctoring.start_video}:</p>
                    <div style={{position:'relative', paddingTop:'56.25%'}} className="mb-2">
                        <iframe
                            src="https://customer-1yv0msz4xbgoinoh.cloudflarestream.com/c8d9c747eee37b44456155b9805186c9/iframe?muted=true&autoplay=true&poster=https%3A%2F%2Fcustomer-1yv0msz4xbgoinoh.cloudflarestream.com%2Fc8d9c747eee37b44456155b9805186c9%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
                            loading="lazy"
                            style={{
                                border: 'none',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                height: '100%',
                                width: '100%',
                            }}
                            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                            allowFullScreen="true"
                        ></iframe>
                    </div>
                    {
                        !navigator.userAgent.includes("Chrome") &&
                        <div className="chrome_banner">
                            <img src={chrome_img} />
                            <p className="mb-0">{t.proctoring.chrome}</p>
                        </div>
                    }
                    <small style={{fontSize:'10px'}}>{t.proctoring.privacy_text} <a target="_blank" href={`${API_URL}${appInfo?.privacy_document_url}`}>{t.proctoring.here}</a></small>
                    <Button className="mt-2 w-100 mx-auto" onClick={confirmClose} color="primary">
                        {t.proctoring.start_proctoring}
                    </Button>
                    <small className="mt-2">{t.proctoring.privacy_accept}</small>
                    <Button className="mt-2 w-100 mx-auto"onClick={onCloseModal} color="secondary">
                        {t.buttons.discard}
                    </Button>
                    
                </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}